import $ from 'jquery';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export default class ContentCards {
    constructor() {
        if($('.js-content-cards').length) {
            const $contentCardSlider = $('.js-content-cards');
            const $contentCardParent = $('.js-content-cards__parent');

            $contentCardSlider.each(function() {
                const $slider = $(this)[0];

                const contentCardSlider = new Swiper($slider, {
                    autoHeight: $contentCardParent.hasClass('has-equal-card-height') ? false : true,
                    loop: true,
                    modules: [
                        Pagination
                    ],
                    pagination: {
                        clickable: true,
                        el: '.swiper-pagination'
                    },
                    slidesPerView: 1,
                    breakpoints: {
                        768: {
                            slidesPerGroup: 2,
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerGroup: 3,
                            slidesPerView: 3,
                            spaceBetween: 20
                        }
                    }
                });
            });

            // Set height of all c-content-cards__item-title elements to height of tallest c-content-cards__item-title element
            $('.js-content-cards__item-title').each(function() {
                const $this = $(this);

                if($this.height() > $('.js-content-cards__item-title').height()) {
                    $('.js-content-cards__item-title').height($this.height());
                };
            });
        };
    };
};
